// events
export const ADD_EVENT = "ADD_EVENT";
export const UPDATE_EVENT = "UPDATE_EVENT";
export const SET_ACTIVE_FILTER = "SET_ACTIVE_FILTER";
export const SHOW_ADD_EVENT = "SHOW_ADD_EVENT";

// labels
export const ADD_LABEL = "ADD_LABEL";
export const DELETE_LABEL = "DELETE_LABEL";
export const IS_MODAL_OPEN = "IS_MODAL_OPEN";
